import React, { ReactNode, useState } from "react";
import Tag from "../../../../../generic/tag";
import OverflowButton from "../../../../../generic/overflowButton";
import { INfo } from "../../../../../types/components/orderBook/obTypes";
import bStrg from "../../../../../service/storageHelper";
import { HObGroupBy } from "../../../../../service/orderBook/obGrpByHelper";
import {
  ChipStatusComb,
  ChipColorKeyComb,
  ovrOptions,
} from "../../../obConstants";
import indexer, { IListObj } from "../../../../../types/genericTypes";
import moment from "moment";
import { obTglDetail } from "../../../../../service/orderBook/obToggler";
import "../../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsDsk.scss";
import "../../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsTab.scss";

export interface ObNfoProps {
  data: Array<INfo>;
  isHistory: boolean;
  noDataNode: ReactNode;
}

// heading for NFO Asset table

const heading = {
  scheme: "Scheme Name",
  amount: "Amount",
};

const ObNfo: React.FC<ObNfoProps> = (props) => {
  //row options start
  const ovrOpts: Array<IListObj> = ovrOptions;
  for (let i = 0; i < props.data.length; i++) {
    const element: INfo = props.data[i];
    var temp: Array<IListObj> = [];
    temp.push(ovrOpts[4]); //details
    element.ovrOpts = temp;
  }
  // wherever initial data needs to be sent, send initialData
  // initial data is array of array for supporting grouping
  const initialData = [props.data],
    todayDate = bStrg("todayDate") || new Date();
  let [tableData, setTableData] = useState(initialData);
  let nfoData: Array<{ [x: string]: Array<INfo> }> | null = null,
    todaysNfos: Array<Array<{}>> | null = null;

  React.useEffect(() => {
    setTableData([props.data]);
  }, [props.data]);

  if (props.data) {
    //group data based on biddingEndDate
    let results = tableData.map((group: Array<any>) =>
      group.reduce(
        (arr: any, d: INfo) => {
          if (
            new Date(d.txnDate).setHours(0, 0, 0).valueOf() ===
            new Date(todayDate).setHours(0, 0, 0).valueOf()
          ) {
            arr[0] = [...arr[0], d];
          } else {
            arr[1] = [...arr[1], d];
          }
          return arr;
        },
        [[], []]
      )
    );
    if (!props.isHistory) {
      todaysNfos = results[0][0].length > 0 ? [results[0][0]] : null;
    } else {
      nfoData =
        results[0][1].length > 0
          ? [HObGroupBy(results[0][1], "txnDate", "T")]
          : null;
    }
  }

  function optSelection(
    id: string | number,
    data: {
      gI: number;
      i: number;
      ordData: indexer;
    }
  ) {
    switch (id) {
      case "cancel":
        // checkPartialOrder(false, data.ordData as IEquity);
        break;
      default:
        //console.log("404");
        break;
    }
  }

  function nfoDetails(item: INfo, groupIndex: number, index: number) {
    return (
      <div
        className="pm_detls_con_wrapper"
        onClick={(e) => obTglDetail(e, ".nfo_table", groupIndex, 1)}
      >
        <div className="ncd_detls_con new_offer_detls_con">
          <div className="top_sec">
            <div className="left_cont ib">
              <span className="time ib">
                {item.txnDate.split("T")[1].split(".")[0]}
              </span>
              <div className="tag_con ib">
                <Tag
                  value={item.txnType === "R" ? "S" : "B"}
                  shape="mini_circle"
                  color="red"
                  height="22px"
                  width="22px"
                />
              </div>
            </div>
            <div className="center_cont ib">
              <h2 className="comp">{item.schemeName}</h2>
            </div>
            <div className="right_cont ib">
              <span className="amt">₹{item.amount}</span>
              <Tag
                value={ChipStatusComb[item.status.toLowerCase()]}
                shape="chip"
                color={ChipColorKeyComb[item.status.toLowerCase()]}
              />
            </div>
          </div>
          <div className="botm_sec">
            <ul className="dtl_list ib">
              <li>
                <div className="dtl_row">
                  <span className="txt">Action</span>
                  <span className="val">{item.txnType}</span>
                </div>
                <div className="dtl_row">
                  <span className="txt">Exchange Order No.</span>
                  <span className="val">
                    {item.exchangeRefNo === "0" ? "-" : item.exchangeRefNo}
                  </span>
                </div>
                <div className="dtl_row">
                  <span className="txt">Ordered By</span>
                  <span className="val">{item.orderedBy}</span>
                </div>
              </li>
            </ul>
            {(item.status === "ACCEPTED" ||
              item.status === "AMO" ||
              item.status === "ON HOLD") && (
              <div className="btn_con ib">
                <a href="text" className="cncl_btn btn">
                  Cancel Order
                </a>
                {/* <a href="text" className="modfy_btn btn">
								Modify Order
							</a> */}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
  function nfoRw(item: INfo, groupIndex: number, index: number) {
    return (
      <React.Fragment key={index}>
        <li
          className="nfo_data ins_data"
          onClick={(e) => obTglDetail(e, ".nfo_table", groupIndex, 0)}
        >
          <div className="col time">
            <span>{item.txnDate.split("T")[1].split(".")[0]}</span>
          </div>
          <div className="col txn_typ">
            <span>
              <Tag
                value={item.txnType === "R" ? "S" : "B"}
                shape="mini_circle"
                color="red"
                height="22px"
                width="22px"
              />
            </span>
          </div>
          <div className="col scheme">
            <span>{item.schemeName}</span>
          </div>
          <div className="col amt taRight">
            <span>₹{item.amount}</span>
          </div>
          <div className="col sts">
            <span>
              <Tag
                value={ChipStatusComb[item.status.toLowerCase()]}
                shape="chip"
                color={ChipColorKeyComb[item.status.toLowerCase()]}
              />
            </span>
          </div>
          <div className="col menu">
            <OverflowButton
              defaultValue={"modify"}
              dropdownOptions={item.ovrOpts ? item.ovrOpts : []}
              onSelect={(id, item) => optSelection(id, item)}
              onHover={true}
              data={{
                ordData: item,
                gI: groupIndex,
                ind: index,
              }}
            />
          </div>
        </li>
        {nfoDetails(item, groupIndex, index)}
      </React.Fragment>
    );
  }
  return (
    <>
      {((nfoData !== null && props.isHistory) ||
        (todaysNfos !== null && !props.isHistory)) && (
        <div className="nfo_table ins_tabl">
          {/* ob NFO Header Row */}

          <ul className="hdr_row">
            <li>
              <div className="col time"> </div>
              <div className="col txn_typ"> </div>
              <div className="col scheme">{heading.scheme}</div>
              <div className="col amt taRight">{heading.amount}</div>
              <div className="col sts"></div>
              <div className="col menu"></div>
            </li>
          </ul>
          {/* ob NCD content Row */}

          {
            props.isHistory
              ? nfoData !== null &&
                nfoData.map((group, groupIndex) =>
                  Object.keys(group).map((date, GIindex) => {
                    return (
                      <React.Fragment key={GIindex}>
                        {/* if history componenet need to show*/}

                        <ul
                          className="eq_hist_date hist_date"
                          key={"dtGp" + GIindex}
                        >
                          <li>{moment(date).format("d MMMM YYYY")}</li>
                        </ul>
                        <ul key={"dtUlDet" + GIindex}>
                          {group[date].map((row: any, index: number) =>
                            nfoRw(row, GIindex, index)
                          )}
                        </ul>
                      </React.Fragment>
                    );
                  })
                )
              : todaysNfos !== null &&
                todaysNfos.map((group: any, groupIndex: number) =>
                  // Object.keys(group).map((grp: any, index) =>
                  {
                    return (
                      <React.Fragment key={groupIndex}>
                        {group.length > 0 && (
                          <ul key={groupIndex}>
                            {group.map((row: any, index: number) => (
                              <React.Fragment key={index}>
                                {nfoRw(row, groupIndex, index)}
                              </React.Fragment>
                            ))}
                          </ul>
                        )}
                      </React.Fragment>
                    );
                  }
                )
            // )
          }
        </div>
      )}
      {((nfoData === null && props.isHistory) ||
        (todaysNfos === null && !props.isHistory)) &&
        props.noDataNode}
    </>
  );
};

export default ObNfo;
